/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { LocoStatusComponent } from './loco-status.component';
import { LocoStatusContainerComponent } from './../loco-status/data/loco-status-container/loco-status-container.component';
import { LocoStatusContainerDataComponent } from './data/loco-status-container-data/loco-status-container-data.component';
import { LocoStatusContainerDataRowComponent } from './data/loco-status-container-data-row/loco-status-container-data-row.component';
import { LocoStatusContainerHeaderComponent } from './data/loco-status-container-header/loco-status-container-header.component';
import { LocoStatusDataComponent } from './data/loco-status-data.component';
import { LocoStatusHeaderComponent } from './../loco-status/data/loco-status-header/loco-status-header.component';
import { LocoStatusResolver } from './shared/loco-status.resolver';
import { LocoStatusRoutingModule } from './loco-status-routing.module';
import { LocoStatusService } from './../loco-status/shared/services/loco-status.service';
import { LocoStatusSubHeaderComponent } from './data/loco-status-sub-header/loco-status-sub-header.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

/**
 * @export
 * @class LocoModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        InputMaskModule,
        DialogModule,
        SplitButtonModule,
        RadioButtonModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        LocoStatusRoutingModule
    ],
    providers: [LocoStatusResolver, LocoStatusService],
    declarations: [
        LocoStatusComponent,
        LocoStatusHeaderComponent,
        LocoStatusContainerComponent,
        LocoStatusSubHeaderComponent,
        LocoStatusContainerHeaderComponent,
        LocoStatusContainerDataComponent,
        LocoStatusContainerDataRowComponent,
        LocoStatusDataComponent
    ],
    exports: [LocoStatusComponent]
})
export class LocoStatusModule { }
